export const WAYUP_API_HEADER_NAMES = {
  appVersion: "Wayup-App-Version",
  platform: "Wayup-Platform",
  userAgent: "Wayup-User-Agent"
} as const;

export type WayupApiClientPlatform = "android" | "ios" | "web";

type WayupApiClientMetadata = {
  appVersion: string;
  platform: WayupApiClientPlatform;
  userAgent?: string;
};

export const buildWayupApiClientHeaders = ({
  appVersion,
  platform,
  userAgent
}: WayupApiClientMetadata): Record<string, string> => ({
  [WAYUP_API_HEADER_NAMES.appVersion]: appVersion,
  [WAYUP_API_HEADER_NAMES.platform]: platform,
  ...(platform === "web" && userAgent
    ? { [WAYUP_API_HEADER_NAMES.userAgent]: userAgent }
    : {})
});
